import { UrlFetcher } from '@flowus/common/hooks/url-fetcher';
import { request } from 'src/common/request';
import { getIsProSpace } from 'src/hooks/space/use-is-pro-space';

export const urlFetcher = new UrlFetcher({
  request,
  isProSpace: () => {
    // 只有非 buildin 和非 private 的情况下才判断是否需要限速
    if (__BUILD_IN__ || __PRIVATE__) {
      return true; // 返回 true 表示不需要限速
    }
    return getIsProSpace();
  },
});
